var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 15,
    viewBox: "0 4.5 24 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#868E96"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.452 10.575C21.85 8.746 17.532 4.5 12.006 4.5c-1.906 0-3.668.502-5.223 1.238l3.008 2.068a4.872 4.872 0 0 1 2.215-.531c2.656 0 4.818 2.12 4.818 4.725 0 .204-.012.409-.042.607l4.42 3.038a22.44 22.44 0 0 0 2.256-2.22 2.136 2.136 0 0 0 0-2.85h-.006z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.006 8.734c-.256 0-.506.03-.744.082l4.043 2.775c-.202-1.612-1.607-2.857-3.299-2.857zm7.986 7.863-3.663-2.517-1.238-.853-5.312-3.65-1.251-.854L5.33 6.527 3.216 5.073a.756.756 0 0 0-1.042.18.728.728 0 0 0 .184 1.017l1.65 1.133c-.429.316-.828.637-1.203.952a22.436 22.436 0 0 0-2.257 2.22 2.136 2.136 0 0 0 0 2.85C2.15 15.255 6.473 19.5 12.006 19.5c1.9 0 3.662-.502 5.217-1.238.506-.24.994-.502 1.459-.789l2.114 1.455a.74.74 0 0 0 .423.134.762.762 0 0 0 .613-.315.728.728 0 0 0-.184-1.017l-1.656-1.133zm-5.777-.403a4.829 4.829 0 0 1-2.21.532c-2.661 0-4.823-2.12-4.823-4.726 0-.21.012-.414.042-.613.065-.52.226-1.016.452-1.466l1.24.853c-.156.38-.245.794-.245 1.226 0 .135 0 .275.03.403.202 1.618 1.608 2.862 3.305 2.862a3.317 3.317 0 0 0 2.227-.847l1.245.86c-.37.367-.792.683-1.263.916z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClose);
export default __webpack_public_path__ + "static/media/eye_close.d816630f.svg";
export { ForwardRef as ReactComponent };